export default {
  title: 'Maintenance',
  new_request: 'New Request',
  form_title: 'Submit Maintenance Request',
  title_label: 'Title',
  title_placeholder: 'Brief description of the issue',
  category_label: 'Category',
  category_note: 'Category details',
  category_note_placeholder: 'Tell us more about the issue type',
  category_placeholder: 'Select category',
  description_label: 'Description',
  description_placeholder: 'Describe the issue in detail',
  photo_label: 'Photo (optional)',
  photo_upload_failed: 'Photo upload failed. Please try again or remove the photo.',
  take_photo: 'Take Photo',
  no_requests: 'No maintenance requests',
  submit_success: 'Request submitted successfully',
  no_active_lease: 'You need an active lease to submit a request',
}
